import { render, staticRenderFns } from "./article-item.vue?vue&type=template&id=4e0f5640&lang=pug&"
import script from "./article-item.vue?vue&type=script&lang=js&"
export * from "./article-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports